import { useCallback } from "react";
import useUpdateShopTrackingPreferences from "@babackapp/private-api-client/client/use-update-shop-tracking-preferences";
import useCurrentShopSuspense from "./use-current-shop-suspense";

export function useSetDefaultTemplate() {
  const updateTrackingPreferences = useUpdateShopTrackingPreferences();
  const { data: shop } = useCurrentShopSuspense();

  const setDefaultTemplate = useCallback(
    (templateId: string) => {
      updateTrackingPreferences.mutate({
        shopId: shop.id,
        requestBody: {
          defaultWebTemplateId: templateId,
        },
      });
    },
    [shop.id, updateTrackingPreferences],
  );

  const isDefaultTemplate = useCallback(
    (templateId: string) => {
      return (
        shop.trackingPreferences.defaultWebTemplateId &&
        shop.trackingPreferences.defaultWebTemplateId === templateId
      );
    },
    [shop.trackingPreferences.defaultWebTemplateId],
  );

  return {
    setDefaultTemplate,
    isDefaultTemplate,
  };
}
